import { ICON_COLOR } from '@zep-us/zus/tokens';
import { PenPaperFillIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
export const BuildSimplePrompt = ({
  prompt,
  onShowFullPromptClick
}: {
  prompt: string;
  onShowFullPromptClick: () => void;
}) => {
  return <div className={'flex items-center justify-between gap-md rounded-md border border-alternative px-md py-lg'} data-sentry-component="BuildSimplePrompt" data-sentry-source-file="BuildAiSimplePrompt.tsx">
      <span className={'items-center truncate rounded  text-heading-md-bold text-default'}>
        {prompt}
      </span>
      <IconButton rounded={'full'} intent={'alternative'} onClick={onShowFullPromptClick} data-sentry-element="IconButton" data-sentry-source-file="BuildAiSimplePrompt.tsx">
        <PenPaperFillIcon fill={ICON_COLOR.neutral} size={'md'} data-sentry-element="PenPaperFillIcon" data-sentry-source-file="BuildAiSimplePrompt.tsx" />
      </IconButton>
    </div>;
};